// Styles for DestinationOverview go here.
import styled from 'styled-components';

export const StyledDestinationOverview = styled.div``;
